import { Grid, Typography } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import IconButton from "@mui/material/IconButton";
import React, { useEffect } from "react";
import { downloadFile } from "src/app-redux/common-actions";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { getWeightScanExistingDocuments } from "src/app-redux/vehicle/actions/vehicleActions";
import {
  currentSelectedIsNodWeightFile,
  currentSelectedVehicleWeightId,
  loader as vehicleLoader,
} from "src/app-redux/vehicle/vehicleSlice";
import doc from "src/assets/images/file_formats_logos/doc.svg";
import img from "src/assets/images/file_formats_logos/img.svg";
import pdf from "src/assets/images/file_formats_logos/pdf.svg";
import xlsx from "src/assets/images/file_formats_logos/xlsx.svg";
import { useStyles } from "./style";
import CommonLoader from "src/components/Loader/CommonLoader";

export interface IDrawerFilesProps {
  refreshDrawer: number;
}

export default function DrawerFiles(props: IDrawerFilesProps) {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const selectedVehicleWeightId: any = useAppSelector(currentSelectedVehicleWeightId);
  const selectedIsNodWeightFile: any = useAppSelector(currentSelectedIsNodWeightFile);
  const loader2: any = useAppSelector(vehicleLoader);

  const [existingFiles, setexistingFiles] = React.useState<any[]>([]);

  useEffect(() => {
    getExistingDocs();
  }, [props.refreshDrawer]);

  const getExistingDocs = async () => {
    const res: any = await dispatch(
      getWeightScanExistingDocuments({
        id: selectedVehicleWeightId,
        isScan: false,
        isNodWeightFile: selectedIsNodWeightFile,
      })
    );
    if (res.payload.length) {
      setexistingFiles(res.payload);
    }
  };

  const downloadDocument = async (item: any) => {
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-doc-by-id/${item.id}?docType=3`,
      contentType: ".jpg",
      fileName: item.title,
    };
    dispatch(downloadFile(fileMetaData));
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader2}>
        <CommonLoader />
      </Backdrop>
      <div className={classes.drawerDetails}>
        {/* Drawer Status Item  */}

        <Grid container spacing={2} className="topContainer" style={{ marginTop: "5px" }}>
          <Grid container direction="row" className="itemRow" spacing={2}>
            <Grid
              item
              md={12}
              id="main-div"
              className={classes.drawerDetails}
              style={{
                height: "max-content",
              }}
            >
              <Grid container direction="row">
                {/* History Item  */}
                {existingFiles.length !== 0 ? (
                  existingFiles.map((item: any) => (
                    <Grid md={6} key={item.id} style={{ padding: "5px" }}>
                      <Grid container direction="row" className="itemRowTrail">
                        <Grid md={3} style={{ padding: "5px" }}>
                          <img
                            src={
                              item.extension === "doc" || item.extension === "docx"
                                ? doc
                                : item.extension === "jpg" ||
                                  item.extension === "jpeg" ||
                                  item.extension === "png"
                                ? img
                                : item.extension === "pdf"
                                ? pdf
                                : item.extension === "xlsx"
                                ? xlsx
                                : img
                            }
                            alt={item.extension}
                            width="25px"
                          />
                        </Grid>
                        <Grid md={6}>
                          <Typography className="subHeading itemName">
                            {item.originalFileName}
                          </Typography>
                        </Grid>
                        <Grid md={2}>
                          <IconButton
                            // style={{ paddingTop: 0 }}
                            onClick={() => {
                              downloadDocument(item);
                            }}
                          >
                            <CloudDownloadIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <div></div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
